var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1404,
    height: 479,
    viewBox: "0 0 1404 479",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1137.32 154.588L986.299 155.168C974.072 155.214 968.74 139.404 978.72 132.339C978.859 132.24 979.001 132.143 979.143 132.044C993.353 122.194 1012.05 123.014 1012.05 123.014C1012.05 123.014 1014.52 70.0221 1064.83 69.8295C1089.71 69.7332 1109.97 112.175 1109.97 112.175C1109.97 112.175 1143.81 112.044 1149.51 138.739C1151.23 146.824 1145.59 154.557 1137.32 154.588Z",
    fill: "#13263C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1137.32 154.588L986.299 155.168C974.072 155.214 968.74 139.404 978.72 132.339C978.859 132.24 979.001 132.143 979.143 132.044C993.353 122.194 1012.05 123.014 1012.05 123.014C1012.05 123.014 1014.52 70.0221 1064.83 69.8295C1089.71 69.7332 1109.97 112.175 1109.97 112.175C1109.97 112.175 1143.81 112.044 1149.51 138.739C1151.23 146.824 1145.59 154.557 1137.32 154.588Z",
    stroke: "#1C314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.145 396.545L27.0886 397C17.4493 397.037 13.2456 384.623 21.1139 379.077C21.2234 379 21.3351 378.923 21.4469 378.845C32.6501 371.112 47.3932 371.756 47.3932 371.756C47.3932 371.756 49.3389 330.151 89.0013 330C108.611 329.925 124.586 363.246 124.586 363.246C124.586 363.246 151.261 363.143 155.754 384.102C157.116 390.449 152.663 396.52 146.145 396.545Z",
    stroke: "#1C314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.8 238.435L306.747 239.213C323.178 239.276 330.344 218.03 316.933 208.538C316.744 208.404 316.554 208.271 316.363 208.139C297.269 194.902 272.135 196.002 272.135 196.002C272.135 196.002 268.819 124.53 201.21 124.53C153.401 124.53 140.55 181.437 140.55 181.437C140.55 181.437 95.0797 181.262 87.4185 217.136C85.0977 228.002 92.6874 238.393 103.8 238.435Z",
    fill: "#13263C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.8 238.435L306.747 239.213C323.178 239.276 330.344 218.03 316.933 208.538C316.744 208.404 316.554 208.271 316.363 208.139C297.269 194.902 272.135 196.002 272.135 196.002C272.135 196.002 268.819 124.53 201.21 124.53C153.401 124.53 140.55 181.437 140.55 181.437C140.55 181.437 95.0797 181.262 87.4185 217.136C85.0977 228.002 92.6874 238.393 103.8 238.435Z",
    stroke: "#1C314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M703.49 78.8167L783.404 78.5086C790.549 78.4824 793.594 69.2199 787.731 65.1383C787.647 65.0819 787.565 65.0241 787.482 64.9677C779.135 59.2765 768.211 59.8377 768.211 59.8377C768.211 59.8377 766.533 28.8875 737.137 29.0003C710.561 29.1021 700.063 55.2264 696.297 69.6106C695.072 74.2838 698.659 78.836 703.49 78.8167Z",
    fill: "#13263C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M703.49 78.8167L783.404 78.5086C790.549 78.4824 793.594 69.2199 787.731 65.1383C787.647 65.0819 787.565 65.0241 787.482 64.9677C779.135 59.2765 768.211 59.8377 768.211 59.8377C768.211 59.8377 766.533 28.8875 737.137 29.0003C710.561 29.1021 700.063 55.2264 696.297 69.6106C695.072 74.2838 698.659 78.836 703.49 78.8167Z",
    stroke: "#1C314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M405.406 343.822L679.088 344.825C704.779 344.92 703.677 323.762 695.313 316.361C686.741 308.775 669.735 311.778 669.735 311.778C669.735 311.778 664.728 297.531 648.1 290.543C633.391 284.362 617.947 287.221 617.947 287.221C617.947 287.221 617.983 277.457 608.58 269.335C599.177 261.213 586.599 261.953 586.599 261.953C586.599 261.953 578.15 208.08 520.378 207.87C462.607 207.658 455.74 258.33 455.74 258.33C455.74 258.33 442.771 258.283 433.307 266.895C423.843 275.507 422.628 285.328 422.628 285.328C422.628 285.328 391.099 280.961 381.671 308.138C376.053 324.335 387.404 343.756 405.406 343.822Z",
    fill: "#13263C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M405.406 343.822L679.088 344.825C704.779 344.92 703.677 323.762 695.313 316.361C686.741 308.775 669.735 311.778 669.735 311.778C669.735 311.778 664.728 297.531 648.1 290.543C633.391 284.362 617.947 287.221 617.947 287.221C617.947 287.221 617.983 277.457 608.58 269.335C599.177 261.213 586.599 261.953 586.599 261.953C586.599 261.953 578.15 208.08 520.378 207.87C462.607 207.658 455.74 258.33 455.74 258.33C455.74 258.33 442.771 258.283 433.307 266.895C423.843 275.507 422.628 285.328 422.628 285.328C422.628 285.328 391.099 280.961 381.671 308.138C376.053 324.335 387.404 343.756 405.406 343.822Z",
    stroke: "#1C314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1239.71 303.278L1324.56 303.604C1331.43 303.63 1334.42 294.748 1328.82 290.78C1328.74 290.724 1328.66 290.669 1328.58 290.614C1320.59 285.079 1310.09 285.539 1310.09 285.539C1310.09 285.539 1308.7 255.769 1280.44 255.66C1266.46 255.607 1255.08 279.45 1255.08 279.45C1255.08 279.45 1236.07 279.377 1232.86 294.373C1231.89 298.917 1235.07 303.26 1239.71 303.278Z",
    fill: "#13263C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1239.71 303.278L1324.56 303.604C1331.43 303.63 1334.42 294.748 1328.82 290.78C1328.74 290.724 1328.66 290.669 1328.58 290.614C1320.59 285.079 1310.09 285.539 1310.09 285.539C1310.09 285.539 1308.7 255.769 1280.44 255.66C1266.46 255.607 1255.08 279.45 1255.08 279.45C1255.08 279.45 1236.07 279.377 1232.86 294.373C1231.89 298.917 1235.07 303.26 1239.71 303.278Z",
    stroke: "#1C314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.02435 48.6182L92.8685 48.9442C99.7387 48.9703 102.734 40.0875 97.1277 36.12C97.0479 36.0636 96.9681 36.0086 96.8897 35.9536C88.9052 30.4192 78.3977 30.8787 78.3977 30.8787C78.3977 30.8787 77.011 1.10877 48.7475 1.00009C34.7719 0.946439 23.388 24.7899 23.388 24.7899C23.388 24.7899 4.37878 24.717 1.1748 39.7133C0.204942 44.2572 3.37865 48.6003 8.02435 48.6182Z",
    fill: "#13263C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.02435 48.6182L92.8685 48.9442C99.7387 48.9703 102.734 40.0875 97.1277 36.12C97.0479 36.0636 96.9681 36.0086 96.8897 35.9536C88.9052 30.4192 78.3977 30.8787 78.3977 30.8787C78.3977 30.8787 77.011 1.10877 48.7475 1.00009C34.7719 0.946439 23.388 24.7899 23.388 24.7899C23.388 24.7899 4.37878 24.717 1.1748 39.7133C0.204942 44.2572 3.37865 48.6003 8.02435 48.6182Z",
    stroke: "#1C314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M665.651 478H640.053C630.049 478 621.939 469.789 621.939 459.661V432.785L617.562 418.171C644.685 418.29 682.744 418.766 688.141 418.171L683.765 432.785V459.661C683.765 469.789 675.654 478 665.651 478Z",
    fill: "#13263C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M665.651 478H640.053C630.049 478 621.939 469.789 621.939 459.661V432.785L617.562 418.171C644.685 418.29 682.744 418.766 688.141 418.171L683.765 432.785V459.661C683.765 469.789 675.654 478 665.651 478Z",
    stroke: "#1C314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M652.853 379.975V416.937",
    stroke: "#1C314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M614.808 381.39L623.063 419.887L614.808 381.39Z",
    fill: "#13263C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M614.808 381.39L623.063 419.887",
    stroke: "#1C314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M693.1 381.39L683.75 419.887L693.1 381.39Z",
    fill: "#13263C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M693.1 381.39L683.75 419.887",
    stroke: "#1C314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M673.843 381.15L667.094 419.156L673.843 381.15Z",
    fill: "#13263C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M673.843 381.15L667.094 419.156",
    stroke: "#1C314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M632.441 381.15L639.189 419.156L632.441 381.15Z",
    fill: "#13263C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M632.441 381.15L639.189 419.156",
    stroke: "#1C314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M621.692 433.159H683.703",
    stroke: "#1C314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M806.813 188.295C806.813 103.033 738.548 33.9156 654.338 33.9156C570.13 33.9156 501.865 103.033 501.865 188.295C501.865 257.744 609.472 381.452 609.472 381.452H699.205C699.205 381.452 806.813 257.744 806.813 188.295Z",
    fill: "#13263C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M806.813 188.295C806.813 103.033 738.548 33.9156 654.338 33.9156C570.13 33.9156 501.865 103.033 501.865 188.295C501.865 257.744 609.472 381.452 609.472 381.452H699.205C699.205 381.452 806.813 257.744 806.813 188.295Z",
    stroke: "#1C314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M751.55 188.295C751.55 103.033 708.027 33.9156 654.338 33.9156C600.65 33.9156 557.126 103.033 557.126 188.295C557.126 257.744 625.733 381.452 625.733 381.452H682.944C682.944 381.452 751.55 257.744 751.55 188.295Z",
    fill: "#13263C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M751.55 188.295C751.55 103.033 708.027 33.9156 654.338 33.9156C600.65 33.9156 557.126 103.033 557.126 188.295C557.126 257.744 625.733 381.452 625.733 381.452H682.944C682.944 381.452 751.55 257.744 751.55 188.295Z",
    stroke: "#1C314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M687.858 188.295C687.858 103.033 672.852 33.9156 654.339 33.9156C635.828 33.9156 620.821 103.033 620.821 188.295C620.821 257.744 644.476 381.452 644.476 381.452H664.203C664.203 381.452 687.858 257.744 687.858 188.295Z",
    fill: "#13263C"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M687.858 188.295C687.858 103.033 672.852 33.9156 654.339 33.9156C635.828 33.9156 620.821 103.033 620.821 188.295C620.821 257.744 644.476 381.452 644.476 381.452H664.203C664.203 381.452 687.858 257.744 687.858 188.295Z",
    stroke: "#1C314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M708.828 302.864C665.977 302.701 686.289 234.833 740.511 251.271C743.877 156.938 897.921 88.4992 961.018 215.991C979.051 201.835 1019.32 228.858 1010.29 252.307C1030.25 254.085 1045.96 256.456 1058.17 259.559C1086.36 266.732 1080.63 303.975 1051.54 303.602L708.828 302.864Z",
    fill: "#13263C"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M708.828 302.864C665.977 302.701 686.289 234.833 740.511 251.271C743.877 156.938 897.921 88.4992 961.018 215.991C979.051 201.835 1019.32 228.858 1010.29 252.307C1030.25 254.085 1045.96 256.456 1058.17 259.559C1086.36 266.732 1080.63 303.975 1051.54 303.602L708.828 302.864Z",
    stroke: "#1C314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M867.347 321.18H974.824",
    stroke: "#1C314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M834.332 321.18H813.29C813.426 319.804 813.561 318.428 813.698 317.053",
    fill: "#13263C"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M834.332 321.18H813.29C813.426 319.804 813.561 318.428 813.698 317.053",
    stroke: "#1C314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M485.612 364.511H516.564",
    stroke: "#1C314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M231.811 261.34H256.572",
    stroke: "#1C314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M39 413H63.761",
    stroke: "#1C314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1267.56 96.5119L1395.19 96.9999C1405.52 97.0396 1410.02 83.701 1401.59 77.7416C1401.47 77.6578 1401.35 77.574 1401.23 77.4911C1389.23 69.1807 1373.42 69.8717 1373.42 69.8717C1373.42 69.8717 1371.34 25 1328.82 25C1298.76 25 1290.67 60.727 1290.67 60.727C1290.67 60.727 1262.08 60.6173 1257.26 83.1396C1255.8 89.9618 1260.58 96.4852 1267.56 96.5119Z",
    fill: "#13263C"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1267.56 96.5119L1395.19 96.9999C1405.52 97.0396 1410.02 83.7009 1401.59 77.7416C1401.47 77.6578 1401.35 77.574 1401.23 77.4911C1389.23 69.1807 1373.42 69.8717 1373.42 69.8717C1373.42 69.8717 1371.34 25 1328.82 25C1298.76 25 1290.67 60.727 1290.67 60.727C1290.67 60.727 1262.08 60.6173 1257.26 83.1396C1255.8 89.9618 1260.58 96.4852 1267.56 96.5119Z",
    stroke: "#1C314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1348.03 111.321H1363.59",
    stroke: "#1C314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M398.948 232.452H430.174",
    stroke: "#1C314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M332.919 314.989H361.807",
    stroke: "#1C314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M306.094 314.989H291.503",
    stroke: "#1C314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1081.56 174.236H1127.14",
    stroke: "#1C314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M824.014 112.772H846.805",
    stroke: "#1C314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M927.187 341.814H945.871",
    stroke: "#1C314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanding);
export default __webpack_public_path__ + "static/media/landing.f09b5129d0083bf7301b465170ab09c4.svg";
export { ForwardRef as ReactComponent };